import React, { Fragment, useState } from 'react';
import { Button } from '@squirrellearningltd/go-pupil-components';
import BookLogHistoryItem  from '../BookLogHistoryItem';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import styles from './BookLogHistory.module.scss';

const BookLogHistory = ({ logs }) => {
    const { t } = useTranslation();

    const visibleLogs = 5;
    const [maxVisible, setMaxVisible] = useState(visibleLogs);
    const [allShown, setAllShown] = useState();

    const toggleLogs = () => {
        if (maxVisible === logs.length) {
            setMaxVisible(visibleLogs)
            setAllShown(false);
        } else {
            setMaxVisible(logs.length)
            setAllShown(true)
        }
    }

    return(
        <div className={styles.bookLogHistory}>
            <h3 className={styles.bookLogHistoryTitle}>{t('reading_log_history')}</h3>
            {
                !!logs.length ? (
                    <Fragment>
                        {_.orderBy(logs, ['date'], ['desc']).slice(0, maxVisible).map(log => (
                            <BookLogHistoryItem key={`log-${log.id}`} log={log} />
                        ))}
                        {(logs.length > maxVisible || allShown) && <Button outline onClick={toggleLogs}>{allShown ? t('button.view_less') : t('button.view_all')}</Button>}
                    </Fragment>
                ) : <p>{t('no_reading_log_added_yet')}</p>
            }
        </div>
    )
}

export default BookLogHistory;
